import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    fullWidthContent: {
      width: '100%',
      paddingRight: 300,
    },
    bankCntInner: {
      marginBottom: 15,
      
    },
    bankNanmDropdown: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 10,
    },
    bankAcntInput: {
      flex: 1,
      borderWidth: 1,
      borderColor: '#ccc',
      padding: 10,
      borderRadius: 5,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
      alignItems: "center"
    },
    fullWidth: {
      width: '100%',
    },
    contentSpace: {
      marginVertical: 10,
      marginRight: 0,
      marginLeft: -10,
      flexDirection: 'row',
    },
    dropDownHeader: {
      padding: 10,
      borderWidth: 1,
      borderColor: '#ccc',
      borderRadius: 5,
    },
    dropDownHeaderHide: {
      padding: 10,
      borderWidth: 1,
      borderColor: '#eee',
      borderRadius: 5,
    },
    showDropdown: {
      position: 'absolute',
      backgroundColor: 'white',
      width: '100%',
      top: 50,
      zIndex: 10,
      borderWidth: 1,
      borderColor: '#ccc',
      borderRadius: 5,
    },
    showDropdownAcntType: {
      position: 'absolute',
      backgroundColor: 'white',
      width: '100%',
      top: 50,
      zIndex: 10,
      borderWidth: 1,
      borderColor: '#ccc',
      borderRadius: 5,
    },
    closeIcon: {
      position: 'absolute',
      right: 5,
      top: 5,
      backgroundColor: 'red',
      width: 20,
      height: 20,
      borderRadius: 10,
      justifyContent: 'center',
      alignItems: 'center',
    },
    imagePrevStyle: {
      width: 100,
      height: 100,
      borderRadius: 10,
      margin: 5,
    },
    cancelChequeWidget: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    closeIconChequeImg: {
      position: 'absolute',
      right: 5,
      top: 5,
      backgroundColor: 'red',
      width: 20,
      height: 20,
      borderRadius: 10,
      justifyContent: 'center',
      alignItems: 'center',
    },
    imageUploader: {
      borderWidth: 1,
      borderColor: '#ccc',
      borderRadius: 5,
      padding: 15,
      alignItems: 'center',
      justifyContent: 'center',
      marginVertical: 10,
    },
    responsiveContainer: {
      width: '100%',
      maxWidth: 600,
      alignSelf: 'center',
    },
    responsivePadding: {
      padding: 20,
    },
    flexRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  {
    [maxSize(DEVICE_SIZES.MD)]: {
      responsivePadding: {
        padding: 10,
      },
    },
    [maxSize(DEVICE_SIZES.SM)]: {
      fullWidthContent: {
        paddingRight: 5,
      },
      
    },
    [maxSize(DEVICE_SIZES.XS)]: {
        fullWidthContent: {
          paddingRight: 5,
          
        },
        
      },
  },
);

export default useStyles;
